module.exports = __webpack_public_path__ + "assets/img/29_217_big.446851bf.jpg";